import enFallback from "../i18n/en.json";

let currentLocale = $state(localStorage.getItem("slipstream_locale") || "en");
let translations = $state({});
let loaded = $state(false);

const localeFiles = {
  en: () => import("../i18n/en.json"),
  fr: () => import("../i18n/fr.json"),
  es: () => import("../i18n/es.json"),
  pt: () => import("../i18n/pt.json"),
};

async function loadLocale(locale) {
  if (!localeFiles[locale]) locale = "en";
  const mod = await localeFiles[locale]();
  translations = mod.default || mod;
  loaded = true;
}

// Initial load
queueMicrotask(() => {
  void loadLocale(currentLocale);
});

// Watch for localStorage changes from other tabs
window.addEventListener("storage", (e) => {
  if (e.key === "slipstream_locale" && e.newValue) {
    currentLocale = e.newValue;
    loadLocale(e.newValue);
  }
});

export function t(key, params = {}) {
  const lookup = (src) => {
    let str = src;
    const parts = key.split(".");
    for (const part of parts) {
      if (str && typeof str === "object" && part in str) {
        str = str[part];
      } else {
        return null;
      }
    }
    return typeof str === "string" ? str : null;
  };

  let str = lookup(translations) ?? lookup(enFallback);
  if (!str) return key;

  const appName =
    translations &&
    typeof translations === "object" &&
    translations.app &&
    typeof translations.app.name === "string"
      ? translations.app.name
      : "slipstream";

  // Simple interpolation: {{name}}; {{appName}} defaults from i18n app.name
  const merged = { appName, ...params };
  return str.replace(/\{\{(\w+)\}\}/g, (_, k) => merged[k] ?? `{{${k}}}`);
}

export function getLocale() {
  return currentLocale;
}

export function setLocale(locale) {
  currentLocale = locale;
  localStorage.setItem("slipstream_locale", locale);
  loadLocale(locale);
}

export function isLoaded() {
  return loaded;
}

export const locales = [
  { code: "en", name: "English", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "fr", name: "Fran\u00E7ais", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "es", name: "Espa\u00F1ol", flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "pt", name: "Portugu\u00EAs", flag: "\u{1F1E7}\u{1F1F7}" },
];
